// eslint-disable-next-line no-unused-vars
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import injectIntl from 'common/injectIntl';
import { apiDateFormatter, dateFormat } from 'lib/format';
import { fetchSchedule, setStatusFilter } from './actions';
import FilterGroup from './FilterGroup';
import { isIntlSelector } from 'common/selectors/appSelector';
import { persistentFlagsSelector } from 'common/selectors/flagsSelector';
import routingSelector from 'common/selectors/routingSelector';

export function updateQuery(dispatch, ownProps, newQuery) {
    const { flags, location, fetchAction } = ownProps;
    let { query = {} } = location;
    query = { ...query, ...newQuery, ...flags };
    dispatch(replace({ ...location, query }));
    dispatch(fetchAction(query));
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onSportsFilterChange(option) {
        updateQuery(dispatch, ownProps, {
            categoryId: option.value ? option.value : undefined
        });
    },
    onReplayDateSelectorChange(option) {
        const startDate = new Date();
        const date = startDate.getDate();
        startDate.setDate(date - option.value);
        const endDate = new Date();

        updateQuery(dispatch, ownProps, {
            startDate: apiDateFormatter(startDate),
            endDate: apiDateFormatter(endDate)
        });
    },
    onNetworkFilterChange(option) {
        updateQuery(dispatch, ownProps, {
            channel: option.value || undefined
        });
    },
    onDateSelectorChange(date) {
        updateQuery(dispatch, ownProps, {
            startDate: apiDateFormatter(date)
        });
    },
    onStatusFilterChange(status) {
        dispatch(setStatusFilter(status));

        const { location: { query: { dates } = {} } } = ownProps;
        const hasDatesParam = dates && /^\d{8}/.test(dates);
        let startDate;
        let endDate;
        if (status === 'upcoming' && hasDatesParam) { // for syndicated player
            const start = dates.split('-')[0];
            const today = dateFormat.dateToKey(new Date());
            startDate = start > today ? start : today;
        }

        updateQuery(dispatch, ownProps, {
            type: status,
            startDate,
            endDate
        });
    }
});

const mapStateToProps = (state) => {
    const { locationBeforeTransitions } = routingSelector(state);
    const { pathname = '' } = locationBeforeTransitions || {};
    const isResponsive = pathname !== '/syndicated/player';
    return {
        isIntl: isIntlSelector(state),
        flags: persistentFlagsSelector(state),
        isResponsive
    };
};

const FilterGroupContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(FilterGroup));

FilterGroupContainer.defaultProps = {
    fetchAction: fetchSchedule
};

FilterGroupContainer.propTypes = {
    fetchAction: PropTypes.func
};

export default FilterGroupContainer;



// WEBPACK FOOTER //
// ./app/common/schedule/FilterGroupContainer.js